<template>
  <div class="yxtbiz-teacher-enroll-audit">
    <xxbiz-signup mod="info" :id="aduitId" @callback="callback"></xxbiz-signup>
    <div class="standard-size-16 color-gray-10">
      <div class="mb32 font-bolder">
        {{$t('pc_biz_te_lbl_authentication_information'/* 认证信息 */)}}
        <yxtf-row type="flex" class="mv24 font-normal font-size-14">
          <yxtf-col :span="12" class="nowrap mh2 felx-center">
            <span class="color-gray-7">{{$t('pc_biz_te_lbl_authentication_name'/* 认证名称 */)}}：</span>
            <yxtf-tooltip :open-filter="true"
                          :content="info.authenticationName"
                          placement="top">
              <div class="yxtbiz-teacher-enroll-audit_ellipsis">{{info.authenticationName}}</div>
            </yxtf-tooltip>
          </yxtf-col>
          <yxtf-col :span="12" class="nowrap mh2 felx-center">
            <span class="color-gray-7">{{$t('pc_biz_te_lbl_authentication_time'/* 认证时间 */)}}：</span>
            <yxtf-tooltip :open-filter="true" placement="top">
              <div v-if="info.authenticationStartTime && info.authenticationEndTime" class="yxtbiz-teacher-enroll-audit_ellipsis">{{info.authenticationStartTime}} {{$t('pc_biz_te_lbl_to'/* 至 */)}} {{info.authenticationEndTime}}</div>
              <div slot="content">{{info.authenticationStartTime}}{{$t('pc_biz_te_lbl_to'/* 至 */)}}{{info.authenticationEndTime}}</div>
            </yxtf-tooltip>
            <span v-if="!info.authenticationStartTime && !info.authenticationEndTime">--</span>
          </yxtf-col>
        </yxtf-row>
        <yxtf-row type="flex" class="font-normal font-size-14">
          <yxtf-col :span="12" class="nowrap mh2 felx-center">
            <span class="color-gray-7">{{$t('pc_biz_te_lbl_authentication_type'/* 认证类型 */)}}：</span>
            <span>{{ info && info.targetType
                    ? $t('pc_biz_lbl_certtype_course').d('课程授权认证')
                    : $t('pc_biz_lbl_certtype_lecturer').d('讲师级别认证') }}</span>
          </yxtf-col>
          <yxtf-col :span="12" class="nowrap mh2 felx-center">
            <span class="color-gray-7">{{$t('pc_biz_tit_authentication_detail'/* 认证详情 */).d('认证详情')}}：</span>
            <yxtf-tooltip
              :open-filter="true"
              placement="top"
              :content="authDetail"
              class="yxtbiz-teacher-enroll-audit_ellipsis"
            >
              <span>{{ authDetail }}</span>
            </yxtf-tooltip>
          </yxtf-col>
        </yxtf-row>
      </div>
      <div class="font-bolder">
        {{$t('pc_biz_te_lbl_teaching_information'/* 教学信息 */)}}
        <yxtf-row type="flex" class="mv24 font-normal font-size-14">
          <yxtf-col :span="12" class="nowrap mh2 felx-center">
            <span class="color-gray-7">{{$t('pc_biz_te_lbl_teaching_identity'/* 教学身份 */)}}：</span>
            <yxtf-tooltip v-if="teachingObj.levelName"
                          :open-filter="true"
                          :content="teachingObj.levelName"
                          placement="top">
              <div class="yxtbiz-teacher-enroll-audit_ellipsis">{{teachingObj.levelName}}</div>
            </yxtf-tooltip>
            <div v-else>{{$t('pc_biz_te_lbl_no'/* 无 */)}}</div>
          </yxtf-col>
          <yxtf-col :span="12" class="nowrap mh2 felx-center">
            <span class="color-gray-7">{{$t('pc_biz_te_lbl_teaching_sessions'/* 面授场次 */)}}：</span>
            <span>{{teachingObj.faceCourseCount || '--'}}</span>
          </yxtf-col>
        </yxtf-row>
        <yxtf-row type="flex" class="font-normal font-size-14">
          <yxtf-col :span="12" class="nowrap mh2 felx-center">
            <span class="color-gray-7">{{$t('pc_biz_te_lbl_live_identity'/* 直播场次 */)}}：</span>
            <span>{{teachingObj.liveCourseCount || '--'}}</span>
          </yxtf-col>
          <yxtf-col :span="12" class="nowrap mh2 felx-center">
            <span class="color-gray-7">{{$t('pc_biz_te_lbl_face_courseLength'/* 面授时长 */)}}：</span>
            <span>{{teachingObj.faceCourseLength || '--'}}</span>
          </yxtf-col>
        </yxtf-row>
        <yxtf-row type="flex" class="mv24 font-normal font-size-14">
          <yxtf-col :span="12" class="nowrap mh2 felx-center">
            <span class="color-gray-7">{{$t('pc_biz_te_lbl_live_courseLength'/* 直播时长 */)}}：</span>
            <span>{{teachingObj.liveCourseLength || '--'}}</span>
          </yxtf-col>
          <yxtf-col :span="12" class="nowrap mh2 felx-center">
            <span class="color-gray-7">{{$t('pc_biz_te_lbl_face_satisfaction'/* 面授满意度 */)}}：</span>
            <span>{{teachingObj.faceSatisfaction || '--'}}</span>
          </yxtf-col>
        </yxtf-row>
      </div>
    </div>
  </div>
</template>

<script>
import { i18n } from 'yxt-biz-pc/packages/common-util/changeLangs';
import { getTeachingIdentityInfo, getAuthenticationInfo } from './service';
export default {
  name: 'YxtbizTeacherEnrollAudit',
  name_zh: '讲师报名审核',
  eventList: [
  ],
  props: {
    // 审核中心给的人员记录id
    aduitId: {
      type: String,
      default: '',
      desc: '审核中心给的人员记录id',
      setter: 'StringSetter'
    }
  },
  data() {
    return {
      id: '', // 认证id
      info: {}, // 基本信息
      teachingObj: {} // 教学信息
    };
  },
  computed: {
    // 认证详情显示文案；认证类型不同，获取方式不同
    authDetail() {
      if (!this.info) return '--';
      if (this.info.targetType) {
        return this.info.courseNames || '--';
      } else {
        return this.info.authenticationType
          ? `${this.info.levelName || '--'} (${this.$t('pc_biz_te_lbl_formal').d('正式')})`
          : this.$t('pc_biz_te_lbl_preparatory_lecturer').d('候补讲师');
      }
    }
  },
  created() {
    window.i18n = i18n; // 处理报名组件国际化
  },
  methods: {
    callback(id, data) {
      if (id) {
        this.getAuthenticationInfo(id);
      }
      if (data && data.userId) {
        this.getTeachingIdentityInfo(data.userId);
      }
    },
    // 获取认证基本信息
    getAuthenticationInfo(id) {
      getAuthenticationInfo({ id: id }).then(res => {
        this.info = res;
      });
    },
    // 获取教学身份/教学信息
    getTeachingIdentityInfo(userId) {
      // type:  0 查全部  1 只查教学身份  2 只查授课信息
      getTeachingIdentityInfo({ type: 0, userId }).then(res => {
        this.teachingObj = res; // 用户身份 0 学员 1 候补(预备) 2 讲师
      });
    }
  }
};
</script>
